var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b;
import { Expose, Transform } from 'class-transformer';
import { EUserRoles } from '~/shared/types';
export class ModelUser {
    agreeCookies;
    email;
    firstName;
    hasCommunities;
    id;
    isConfirmed;
    isNewsLetter;
    lang;
    lastName;
    role;
    session;
}
__decorate([
    Expose({ name: 'agree_cookies' }),
    __metadata("design:type", Number)
], ModelUser.prototype, "agreeCookies", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelUser.prototype, "email", void 0);
__decorate([
    Expose({ name: 'first_name' }),
    __metadata("design:type", String)
], ModelUser.prototype, "firstName", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ModelUser.prototype, "hasCommunities", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ModelUser.prototype, "id", void 0);
__decorate([
    Expose({ name: 'is_confirmed' }),
    __metadata("design:type", Boolean)
], ModelUser.prototype, "isConfirmed", void 0);
__decorate([
    Expose({ name: 'is_newsletter' }),
    __metadata("design:type", Number)
], ModelUser.prototype, "isNewsLetter", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ModelUser.prototype, "lang", void 0);
__decorate([
    Expose({ name: 'last_name' }),
    __metadata("design:type", String)
], ModelUser.prototype, "lastName", void 0);
__decorate([
    Expose(),
    Transform(({ value }) => String(value)),
    __metadata("design:type", typeof (_a = typeof EUserRoles !== "undefined" && EUserRoles) === "function" ? _a : Object)
], ModelUser.prototype, "role", void 0);
__decorate([
    Expose(),
    __metadata("design:type", typeof (_b = typeof TUserSession !== "undefined" && TUserSession) === "function" ? _b : Object)
], ModelUser.prototype, "session", void 0);
